import { render, staticRenderFns } from "./infrastructure_icon_and_name.vue?vue&type=template&id=55a4b198&"
import script from "./infrastructure_icon_and_name.vue?vue&type=script&lang=js&"
export * from "./infrastructure_icon_and_name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports